import React from 'react';
import NewsletterSignup from './NewsletterSignup';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer style={{
      backgroundColor: '#000',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '60px 0 40px',
    }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '60px',
          marginBottom: '60px',
        }} className="footer-grid">
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_428d7d2b-13b3-4e32-b545-4fc4e68b2c99/artifacts/5tormzbm_IMG_9806.PNG"
                alt="JM"
                style={{ height: '36px', width: 'auto' }}
              />
              <span style={{
                color: '#ffffff',
                fontFamily: "'Figtree', sans-serif",
                fontSize: '14px',
                fontWeight: '600',
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
              }}>
                Jedrek Magdalena
              </span>
            </div>
            <p style={{
              color: 'rgba(255,255,255,0.4)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '13px',
              fontWeight: '400',
              lineHeight: '1.7',
              maxWidth: '260px',
            }}>
              Sports & Government Advisor. Leadership Strategist. Building systems that win.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 style={{
              color: 'rgba(255,255,255,0.4)',
              fontFamily: "'Figtree', sans-serif",
              fontSize: '11px',
              fontWeight: '600',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              marginBottom: '20px',
            }}>Navigation</h4>
            {[{ label: 'About', href: '#about' }, { label: 'Services', href: '#services' }, { label: 'Membership', href: '#membership' }, { label: 'Blog', href: '/blog' }, { label: 'Contact', href: '#contact' }].map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                style={{
                  display: 'block',
                  background: 'none',
                  border: 'none',
                  color: 'rgba(255,255,255,0.5)',
                  fontFamily: "'Figtree', sans-serif",
                  fontSize: '14px',
                  fontWeight: '400',
                  cursor: 'pointer',
                  padding: '6px 0',
                  textAlign: 'left',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => e.target.style.color = '#ffffff'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Newsletter */}
          <div>
            <NewsletterSignup />
            <div style={{ display: 'flex', gap: '16px', marginTop: '20px' }}>
              {[
                { label: 'LinkedIn', href: 'https://www.linkedin.com/in/jedrek-magdalena-8ba4632a/', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><rect x="2" y="9" width="4" height="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.5"/></svg> },
                { label: 'Facebook', href: 'https://www.facebook.com/JedrekMagdalena', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
                { label: 'Instagram', href: 'https://www.instagram.com/jedrekmagdalena/', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg> },
                { label: 'Email', href: 'mailto:jedrek@jmguru.com', icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target={social.href.startsWith('mailto') ? undefined : '_blank'}
                  rel="noopener noreferrer"
                  title={social.label}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    border: '1px solid rgba(255,255,255,0.1)',
                    color: 'rgba(255,255,255,0.4)',
                    transition: 'border-color 0.2s ease, color 0.2s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; e.currentTarget.style.color = '#ffffff'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'rgba(255,255,255,0.4)'; }}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px',
        }}>
          <span style={{
            color: 'rgba(255,255,255,0.25)',
            fontFamily: "'Figtree', sans-serif",
            fontSize: '12px',
            fontWeight: '400',
          }}>
            &copy; {currentYear} Jedrek Magdalena. All rights reserved.
          </span>
          <span style={{
            color: 'rgba(255,255,255,0.25)',
            fontFamily: "'Figtree', sans-serif",
            fontSize: '12px',
            fontWeight: '400',
          }}>
            Structure. Leadership. Measurable Results.
          </span>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 36px !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
